import translations from "../../utils/translations";

export function ClientLogTable(props) {
  const transInfo = props?.logs;
  const languagepreference = props?.languagepreference;
  const clientLogTranslations = translations[languagepreference].clientLogTable;

  function translateYesAndNo(word) {
    if (languagepreference==="fr"&&word === "Yes") {
      return "Oui";
    } else if (languagepreference==="fr"&&word === "No") {
      return "Non";
    } else {
      return word;
    }
  }

  return (
    <>
      <table style={{ width: "100%", fontSize: "14px" }}>
        <thead>
          <tr>
            <th>{clientLogTranslations.question}</th>
            <th>{clientLogTranslations.oldAnswer}</th>
            <th>{clientLogTranslations.newAnswer}</th>
          </tr>
        </thead>
        <tbody>
          {transInfo.map((row) => {
            if (
              Array.isArray(row.question) ||
              Array.isArray(row.old_answer) ||
              Array.isArray(row.new_answer)
            ) {
              return <></>; //for an empty fragment
            }
            return (
              <tr>
                <td>{row.question}</td>
                <td>{translateYesAndNo(row.old_answer)}</td>
                <td>{translateYesAndNo(row.new_answer)}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
}
